import { useMemo, useState } from "react";
import { Table } from "reactstrap";
import { StatusCorrecaoEquipeEnum } from "services/OrdemServicoService";

export default function Correcoes({ os }) {
  const [todos, setTodos] = useState(false)

  const correcoes = useMemo(() => {
    const lista = os?.correcoes || []
    if (todos) return lista

    const statusAtivos = [
      StatusCorrecaoEquipeEnum.AGUARDANDO_CORRECAO,
      StatusCorrecaoEquipeEnum.EM_CORRECAO,
      StatusCorrecaoEquipeEnum.PAUSADA
    ]

    return lista.filter(co => statusAtivos.includes(co.status))
  }, [os, todos])

  return (
    <div>
      <div className="d-flex justify-content-end align-items-center mb-3 gap-5px">
        <div>Todos</div>
        <label className="custom-toggle" style={{ marginBottom: 0 }}>
          <input type="checkbox" checked={todos} onChange={e => setTodos(e.target.checked)} />
          <span className="custom-toggle-slider rounded-circle" />
        </label>
      </div>

      <Table className="align-items-center table-flush" responsive>
        <thead>
          <tr>
            <th>Equipe</th>
            <th>Status</th>
            <th>Itens</th>
          </tr>
        </thead>
        <tbody>
          {correcoes.length == 0 ? (
            <tr>
                <td colSpan={3} className="text-center">Nenhuma atribuição encontrada</td>
            </tr>
          ) : (
            correcoes.map(co => (
              <tr key={co.id}>
                <td>{co.equipe}</td>
                <td>{co.statusFmt}</td>
                <td style={{ whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                  {co.itens.map((item, idx) => (
                    <div key={`${co.id}-${idx}`}>{item.codigo} - {item.descricao}</div>
                  ))}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  )
}
